import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      // Show only after user has scrolled past the hero (~600px)
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-35">
      <div className="bg-earth-900/95 backdrop-blur-md border-t-2 border-gold-500 px-4 py-3 shadow-2xl" data-id="element-36">
        <a href="https://bienestardigital.click/cart/add?id=43120004464729&quantity=1" className="flex items-center justify-between gap-3 bg-gradient-to-r from-terracotta-600 to-terracotta-700 hover:from-terracotta-700 hover:to-terracotta-800 text-white font-bold rounded-2xl px-4 py-3 shadow-lg active:scale-[0.98] transition" data-id="element-37">
          <div className="flex items-center gap-2 min-w-0" data-id="element-38">
            <Flame className="w-5 h-5 text-gold-400 flex-shrink-0 animate-pulse" data-id="element-39" />
            <div className="text-left leading-tight min-w-0" data-id="element-40">
              <p className="text-xs uppercase tracking-wider text-gold-400 font-bold" data-id="element-41">
                82% OFF · Hoy
              </p>
              <p className="text-sm font-black truncate" data-id="element-42">
                QUIERO ALIVIAR MI DOLOR
              </p>
            </div>
          </div>
          <div className="text-right leading-tight flex-shrink-0" data-id="element-43">
            <p className="text-[10px] line-through text-sand-300/70" data-id="element-44">
              $111.920
            </p>
            <p className="text-lg font-black text-gold-400" data-id="element-45">$19.990</p>
          </div>
        </a>
      </div>
    </div>;
}